import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from '../components/dialogs/confirm-dialog/confirm-dialog.component';
import { PasswordConfirmationDialogComponent } from '../components/dialogs/password-confirmation-dialog/password-confirmation-dialog.component';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class PromptService {

  private snackBarDuration: number = 3000;

  constructor(
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
  ) { }
  
  openSnackBar(message: string, duration?: number, inModal?: boolean){

    let panelClass = ['snackbar'];
    if (inModal === true){ panelClass.push('modal-snackbar')};
    this.snackbar.open(message, "Close", {
      duration: duration == null ? this.snackBarDuration : duration,
      panelClass
    });
  }

  openConfirmationDialog(promptMessage: string){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      autoFocus: false,
      data: { message:  promptMessage }
    });

    return dialogRef;
  }
  
  openCustomDialog(promptData: {message: string, note: any, messageClass: any, noteClass: any}){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      autoFocus: false,
      data: { 
        ...promptData,
        customText: true,
        defaultTemplate: true
      }
    });

    return dialogRef;
  }

  openPasswordDialog(){
    const dialogRef = this.dialog.open(PasswordConfirmationDialogComponent, {
      autoFocus: false,
    });

    return dialogRef;
  }

  openSwalSuccess(title: string, message: string){
    return Swal.fire({
      title: title,
      text: message ?? 'Successful',
      icon: 'success',
      heightAuto: false,
      confirmButtonText: 'Close',
      customClass: {
        confirmButton: "cancelButton",
      }
    })
  }

  
  openSwalError(title: string, message: string, htmlContent?: string){
    return Swal.fire({
      title: title,
      text: htmlContent == null ? (message ?? 'Successful') : null,
      html: htmlContent ?? null,
      icon: 'error',
      heightAuto: false,
      confirmButtonText: 'Close',
      customClass: {
        confirmButton: "cancelButton",
      }
    })
  }

  openSwalWarning(title: string, message: string, htmlContent?: string){
    return Swal.fire({
      title: title,
      text: htmlContent == null ? (message ?? 'Warning') : null,
      html: htmlContent ?? null,
      icon: 'warning',
      heightAuto: false,
      confirmButtonText: 'Okay',
      customClass: {
        confirmButton: "cancelButton",
      },
      width: 'fit-content'
    })
  }

  
}
